import { validate } from 'validate.js';
import { getCurrentLanguage } from '../utils/currentLanguage';
import { getConstraints } from './common.js';
function getAllConstraints() {
    const localizedConstraints = getConstraints(getCurrentLanguage());
    const passwordConstraints = {
        newPassword: localizedConstraints.Password,
        repeatedNewPassword: {
            equality: {
                attribute: 'newPassword',
                message: 'Passordene er ikke like!',
            },
        },
    };
    return {
        passwordConstraints: passwordConstraints,
        newMobilePhoneNumber: localizedConstraints.PhoneNumber,
        line1: localizedConstraints.StreetName,
        postalCode: localizedConstraints.PostalCode,
        city: localizedConstraints.PostalCity,
        countryId: localizedConstraints.CountryId,
    };
}
export function validateUpdateSingle(valueToValidate, valueIndex) {
    const constraints = getAllConstraints();
    if (valueIndex === "repeatedNewPassword") {
        return validate({ ...valueToValidate }, constraints.passwordConstraints, { format: 'detailed' });
    }
    // @ts-ignore
    return validate.single(valueToValidate[valueIndex], constraints[valueIndex], { format: 'detailed' });
}
